<template>
  <div class="container">
    <div class="main">
      <div class="module_section1">
        <h3 class="title">大数据解决方案</h3>
        <p class="cont">提供主流的大数据组件，覆盖能源数据采集、存储、处理分析、展示等各环节，提供高性能、高可靠的能源大数据业务基础资源，帮助企业驱动业务决策和产品智能</p>
        <!-- <a href="javascript:;" class="btn" @click="goToLink('/index?id=applyUse')">
          方案咨询
          <i class="el-icon-right rightIcon1"></i>
        </a> -->
      </div>
      <div class="navs">
        <ul class="module">
          <li 
            v-for="(el, ind) in navs" 
            :key="ind" 
            :class="el.actived ? 'actived' : ''"
            @click="handleChangeNav(ind, 'navs', el)"
            >
              {{el.name}}<span></span>
          </li>
        </ul>
      </div>
      <div class="module module_section2">
        <p class="title_com" id="solution">大数据解决方案</p>
        <div class="solution_cont">
          <div class="item" v-for="(el, ind) in solutionList" :key="ind">
            <img class="img" :src="el.img" alt="">
            <p class="item_title">{{el.title}}</p>
            <p class="item_subTitle">{{el.subTitle}}</p>
          </div>
        </div>
      </div>

      <div class="module_section3">
        <h3 class="title_com" id="case">方案优势</h3>
        <div class="case_cont module">
          <div class="item" v-for="(el, ind) in caseList" :key="ind">
            <img :src="el.img" alt="">
            <p class="title">{{el.title}}</p>
            <p class="subTitle">{{el.subTitle}}</p>
          </div>
        </div>
      </div>
      <div class="module_section4">
        <h3 class="title_com" style="color:#fff">大数据主要特点</h3>
        <img class="characteristic_bg01" src="https://oss.duodians.com/lambda/office_web/bigData/characteristic_bg01.png" alt="">
        <img class="characteristic_bg02" src="https://oss.duodians.com/lambda/office_web/bigData/characteristic_bg02.png" alt="">
        <div class="characteristic_cont module">
          <div class="item" v-for="(el, ind) in characteristicList" :key="ind">
            <img :src="el.img" alt="">
            <div class="cont">
              <p class="title">{{el.title}}</p>
              <p class="subTitle">{{el.subTitle}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="module_section5">
        <h3 class="title_com">大数据的工作流程</h3>
        <div class="workflow module">
          <div class="icon_cont">
            <div class="icon1">
              <img src="https://oss.duodians.com/lambda/office_web/bigData/process_icon01.png" alt="">
            </div>
            <div class="line1"></div>
            <div class="icon2">
              <img src="https://oss.duodians.com/lambda/office_web/bigData/process_icon02.png" alt="">
            </div>
            <div class="line2"></div>
            <div class="icon3">
              <img src="https://oss.duodians.com/lambda/office_web/bigData/process_icon03.png" alt="">
            </div>
            <div class="line3"></div>
            <div class="icon4"></div>
          </div>
          <div class="cont">
            <div class="item" v-for="(el, ind) in workflowList" :key="ind">
              <p class="title">{{ el.title }}</p>
              <p class="text">{{ el.text }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="module_section6">
        <h3 class="title_com" id="architecture">典型部署架构</h3>
        <div class="deploy_cont">
          <div class="module">
            <img class="img" src="https://oss.duodians.com/lambda/office_web/bigData/product_big_img1.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navs: [{
        id: 1,
        name: '大数据解决方案',
        actived: true,
        href: 'solution'
      }, {
        id: 2,
        name: '方案优势',
        actived: false,
        href: 'case'
      }, {
        id: 3,
        name: '典型部署架构',
        actived: false,
        href: 'architecture'
      }],
      solutionList: [{
        img: 'https://oss.duodians.com/lambda/office_web/bigData/solution_icon1.png',
        title: '大数据',
        subTitle: '结合主流的大数据组件和基础云服务，为企业客户提供能源数据分析、电池分析、日志分析、商业数据分析等场景解决方案'
      }, {
        img: 'https://oss.duodians.com/lambda/office_web/bigData/solution_icon2.png',
        title: '数据湖',
        subTitle: '低成本存储海量数据、规模无限扩展、支持多种数据种类，适用于微电网监测分析、工商业储能数据分析、充放电数据分析等应用场景'
      }],
      caseList: [{
        title: '支持高并发',
        subTitle: '根据业务压力进行在线弹性扩展，以应对大容量及高并发请求带来的性能挑战',
        img: 'https://oss.duodians.com/lambda/office_web/bigData/case_icon1.png'
      }, {
        title: '数据安全可靠',
        subTitle: '提供安全可靠、低成本的云端存储服务，提供数据高持久性、服务高可用性',
        img: 'https://oss.duodians.com/lambda/office_web/bigData/case_icon2.png'
      }, {
        title: '资源利用率高',
        subTitle: '采用计算存储分离架构，大幅减少服务器资源成本，资源利用率提升50%',
        img: 'https://oss.duodians.com/lambda/office_web/bigData/case_icon3.png'
      }, {
        title: '开放云生态',
        subTitle: '提供Energy AI、Battery AI等工具组件，为客户提供全方位的AI大数据解决方案',
        img: 'https://oss.duodians.com/lambda/office_web/bigData/case_icon4.png'
      }],
      characteristicList: [{
        title: '巨量数据',
        subTitle: '新能源设备会产生大量的运行数据，例如微电网、储能系统等运行过程中会实时传送海量数据到云',
        img: 'https://oss.duodians.com/lambda/office_web/bigData/characteristic_icon1.png'
      }, {
        title: '多样性强',
        subTitle: '任何形式的数据都可以产生作用，如微电网监测数据、工商业储能数据、充放电数据等多类型的数据格式',
        img: 'https://oss.duodians.com/lambda/office_web/bigData/characteristic_icon2.png'
      }, {
        title: '快速分析',
        subTitle: '对于产生的数据湖，需要及时进行处理，避免无效存储和浪费，通过数据中台技术和算法对源数据及时分类、存储和展示',
        img: 'https://oss.duodians.com/lambda/office_web/bigData/characteristic_icon3.png'
      }, {
        title: '真实性',
        subTitle: '数据内容包含所有原始的数据，不会出现人为简化等因素出现的缺失',
        img: 'https://oss.duodians.com/lambda/office_web/bigData/characteristic_icon4.png'
      }],
      sceneActived: 0,
      workflowList: [{
        title: '海量数据收集',
        text: '从能源、储能和充放电服务等各领域的智能硬件进行端到云的能源数据收集'
      }, {
        title: '海量数据存储',
        text: '基于云技术方面的优势和众多大数据项目的成功经验，可以实现对海量数据进行分布式文件存储'
      }, {
        title: '海量数据计算',
        text: '基于完善的数据仓储和数据中台技术优势，可以按需实现海量数据的实时计算和批量计算'
      }]
    };
  },
  components: {},
  computed: {},
  created() {
  },
  methods: {
    handleChangeNav(ind, type, item) {
      if (type == 'navs') {
        this.navs.forEach(el => el.actived = false)
        this.navs[ind].actived = true
        const element = document.getElementById(item.href);
        element.scrollIntoView({block: 'start', behavior: 'smooth'});
      } else if (type == 'sceneNavs') {
        this.sceneList.forEach(el => el.actived = false)
        this.sceneList[ind].actived = true
        this.sceneActived = ind
      }
    },
    goToLink(url) {
      this.$router.push({ path: url })
    }
  },
};
</script>
<style lang='less' scoped>
.container{
  position: relative;
  top:-80px;
  z-index: 1;
  .main{
    .module{
      width:1200px;
      margin: 0 auto;
    }
    .module_section1{
      color: #fff;
      text-align: center;
      height: 600px;
      background: url('https://oss.duodians.com/lambda/office_web/bigData/product_bg.jpg') no-repeat;
      background-position: center center;
      background-size: 100% 100%;
      .title{
        padding: 170px 0 40px;
        font-size: 48px
      }
      .cont{
        width: 800px;
        margin: 0 auto 42px;
        font-size: 20px;
        line-height: 30px;
        text-align: center;
      }
      .btn{
        width: 148px;
        height: 50px;
        border: 2px solid;
        border-image: linear-gradient(270deg, #4add69 18%, #4cddbd 58%, #3cecf0 43%, #12ee90 99%) 2 2;
        border-radius: 28px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        color: #4cddbd;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        .rightIcon1{
          margin-left: 10px;
        }
      }
    }
    .navs{
      width: 100%;
      height: 50px;
      background: rgba(0,0,0,.3);
      position:sticky;
      z-index: 10;
      top: 0px;
      margin-top: -50px;
      ul{
        display: flex;
        li{
          width: 400px;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: #fff;
          cursor: pointer;
        }
        li.actived{
          background: rgba(0,0,0,.6);
          font-weight: 600;
          span{
            display: block;
            width: 20px;
            height: 4px;
            background: #00AB71;
            border-radius: 2px;
            position: absolute;
            bottom: 0;
          }
        }
      }
    }
    .title_com{
      text-align: center;
      height: 54px;
      font-size: 46px;
      font-family: PingFangSC, PingFangSC-Semibold;
      font-weight: 600;
      color: #000000;
      line-height: 54px;
    }
    .subTitle_com{
      height: 28px;
      text-align: center;
      font-size: 20px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: center;
      color: rgba(0,0,0,.65);
      line-height: 30px;
      margin-top: 30px;
    }
    .module_section2{
      padding-top: 100px;
      height: 858px;
      .solution_cont{
        margin-top: 100px;
        display: flex;
        justify-content: space-between;
        .item{
          width: 634px;
          height: 390px;
          background: #ffffff;
          border: 1px solid #f0f8fd;
          border-radius: 8px;
          box-shadow: 10px 10px 40px 10px rgba(131,143,172,0.06);
          text-align: center;
          cursor: pointer;
          margin-right: 32px;
          .img{
            width: 120px;
            margin-top: 60px;
          }
          .item_title{
            margin-top: 10px;
            height: 42px;
            font-size: 26px;
            font-family: PingFangSC, PingFangSC-Semibold;
            font-weight: 600;
            text-align: center;
            color: #303132;
            line-height: 42px;
          }
          .item_subTitle{
            width: 500px;
            font-size: 18px;
            font-family: SourceHanSansCN, SourceHanSansCN-Regular;
            font-weight: 400;
            text-align: center;
            color: rgba(48,49,50, .8);
            line-height: 24px;
            margin: 18px auto;
          }
        }
        // .item:hover{
        //   -webkit-transform: translateY(-8px);
        //   transform: translateY(-20px);
        //   -webkit-transition: -webkit-transform .5s;
        //   transition: -webkit-transform .5s;
        //   transition: transform .5s;
        //   transition: transform .5s,-webkit-transform .5s;
        // }
      }
    }
    .module_section3{
      padding-top: 100px;
      height: 812px;
      background: #f6fafd;
      .case_cont{
        margin-top: 100px;
        display: flex;
        justify-content: space-between;
        .item{
          width: 300px;
          height: 346px;
          background: #ffffff;
          border-radius: 8px;
          text-align: center;
          padding: 0 28px;
          margin-right: 34px;
          cursor: pointer;
          img{
            width: 100px;
            margin: 40px auto 16px;
          }
          .title{
            height: 40px;
            font-size: 26px;
            font-family: PingFangSC, PingFangSC-Semibold;
            font-weight: 600;
            color: rgba(0,0,0,.85);
            line-height: 40px;
          }
          .subTitle{
            margin-top: 18px;
            font-size: 18px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            text-align: justify;
            color: rgba(0,0,0,.6);
            line-height: 24px;
          }
        }
        .item:last-child{
          margin-right: 0;
        }
        // .item:hover{
        //   -webkit-transform: translateY(-8px);
        //   transform: translateY(-20px);
        //   -webkit-transition: -webkit-transform .5s;
        //   transition: -webkit-transform .5s;
        //   transition: transform .5s;
        //   transition: transform .5s,-webkit-transform .5s;
        //   background: #fff;
        //   border: 1px solid #eef2ff;
        //   border-radius: 0px 24px 24px 24px;
        //   box-shadow: 10px 10px 40px 10px rgba(131,143,172,0.06); 
        // }
      }
    }
    .module_section4{
      height: 960px;
      background: #151e35;
      background-position: center center;
      background-size: 100% 100%;
      padding-top: 100px;
      position: relative;
      .characteristic_bg01{
        position: absolute;
        top: 0;
        left: 0;
        width: 550px;
      }
      .characteristic_bg02{
        position: absolute;
        bottom: 0;
        right: 0;
        width: 900px;
      }
      .characteristic_cont{
        width:1300px;
        margin-top: 100px;
        display: flex;
        flex-wrap: wrap;
        position: relative;
        z-index: 10;
        .item{
          width: 634px;
          height: 280px;
          background: #f6fafd;
          border-radius: 8px;
          text-align: center;
          padding: 0 40px 0;
          margin: 0 32px 32px 0;
          cursor: pointer;
          display: flex;
          align-items: center;
          img{
            width: 120px;
            height: 120px;
            margin-right: 54px;
          }
          .cont{
            width: 380px
          }
          .title{
            height: 40px;
            font-size: 26px;
            font-family: PingFangSC, PingFangSC-Semibold;
            font-weight: 600;
            color: rgba(0,0,0,.85);
            line-height: 40px;
            text-align: left;
          }
          .subTitle{
            margin-top: 18px;
            font-size: 18px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            text-align: justify;
            color: rgba(0,0,0,.6);
            line-height: 24px;
          }
        }
        .item:nth-child(2n){
          margin-right: 0;
        }
      }
    }
    .module_section5{
      padding-top: 100px;
      height: 827px;
      .workflow{
        margin-top: 140px;
        .icon_cont{
          display: flex;
          align-items: center;
          width: 1300px;
          justify-content: center;
          .icon1,.icon2,.icon3{
            width: 150px;
            height: 150px;
            background: #f6fafd;
            border: 6px solid #ffffff;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            img{
              width: 56px;
            }
          }
          .line1, .line2, .line3{
            width: 320px;
            height: 1px;
            border-top: 5px dashed #e8edf2;
          }
          .line3{
            width: 50px;
          }
          .icon4{
            width: 20px;
            height: 20px;
            border: 20px solid #e8edf2;
            border-color: transparent transparent transparent #e8edf2;
          }
        }
        .cont{
          width: 1240px;
          margin-top: 30px;
          display: flex;
          justify-content: space-between;
          .item{
            width: 300px;
            .title{
              opacity: 0.85;
              font-size: 24px;
              font-family: PingFang SC, PingFang SC-Semibold;
              font-weight: 600;
              text-align: center;
              color: #000000;
              line-height: 38px;
              margin-bottom: 5px;
            }
            .text{
              opacity: 0.65;
              margin-top: 18px;
              font-size: 18px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              text-align: center;
              color: #000000;
              line-height: 25px;
            }
          }
        }
      }
    }
    .module_section6{
      height: 960px;
      padding-top: 100px;
      margin-bottom: -80px;
      background: #f6fafd;
      .deploy_cont{
        .module{
          .img{
            margin-left: -50px;
            width: 1300px;
            margin-top: 80px;
          }
        }
      }
    }
  } 
}
/*从右到左进入*/
.fadeInRight{
  animation-name:fadeInRight;
  animation-duration: 2s;
  animation-iteration-count: 1;
  -webkit-animation:fadeInRight;
  -webkit-animation-duration: 2s;
  -webkit-animation-iteration-count: 1;
}

/*从左到右进入*/
.fadeInLeft{
  animation-name:fadeInLeft;
  animation-duration: 2s;
  animation-iteration-count: 1;
  -webkit-animation:fadeInLeft;
  -webkit-animation-duration: 2s;
  -webkit-animation-iteration-count: 1;
}

// 文字渐显
.fadeInText{
  animation-name:fadeInText;
  animation-duration: 2s;
  animation-iteration-count: 1;
  -webkit-animation:fadeInText;
  -webkit-animation-duration: 2s;
  -webkit-animation-iteration-count: 1;
}

/*从左到右进入*/
@keyframes fadeInLeft{
  from {
    opacity:0;
    -webkit-transform:translate(-900px,0);
    transform:stranslate(-900px,0);
  }to{
    opacity:1;
    -webkit-transform:translate(0px,0);
    transform:stranslate(0px,0);
  }
}

@-webkit-keyframes fadeInLeft{
  from {
    opacity:0;
    -webkit-transform:translate(-900px,0);
    transform:stranslate(-900px,0);
  }to{
    opacity:1;
    -webkit-transform:translate(0px,0);
    transform:stranslate(0px,0);
  }
}

/*从右到左进入*/
@keyframes fadeInRight{
  from {
    opacity:0;
    -webkit-transform:translate(900px,0);
    transform:stranslate(900px,0);
  }to{
    opacity:1;
    -webkit-transform:translate(0px,0);
    transform:stranslate(0px,0);
  }
}

@-webkit-keyframes fadeInRight{
  from {
    opacity:0;
    -webkit-transform:translate(900px,0);
    transform:stranslate(900px,0);
  }to{
    opacity:1;
    -webkit-transform:translate(0px,0);
    transform:stranslate(0px,0);
  }
}

/*文字渐显*/
@keyframes fadeInText{
  from {
    opacity:0;
  }to{
    opacity:1;
  }
}

@-webkit-keyframes fadeInText{
  from {
    opacity:0;
  }to{
    opacity:1;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/bigData/bigData.vue